// utils/shouldCaptureCamera.js
export function getPendingCameraTargets(camera, questionNumber) {
  if (!camera || !camera.targets) return []
  return camera.targets.filter(
    (t) => t <= questionNumber && !camera.captured.includes(t)
  )
}

export function shouldCaptureCamera(camera, questionNumber) {
  if (!camera) return false
  return (
    camera.targets.includes(questionNumber) &&
    !camera.captured.includes(questionNumber)
  )
}
